(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/transcript-file/assets/javascripts/handlebarshelpers.js') >= 0) return;  svs.modules.push('/components/accountservices/transcript-file/assets/javascripts/handlebarshelpers.js');
'use strict';

function registerHelpers(hbs) {
  hbs.registerHelper('transcriptType', function(transcriptionStatus) {
    var transcriptionTypes = {
      1: 'registerutdrag',
      2: 'mina spel',
      3: 'kontohistorik'
    };
    return transcriptionTypes[transcriptionStatus.orderType];
  });
  hbs.registerHelper('transcriptFilename', function(transcriptionStatus) {
    var transcriptFilenames = {
      1: 'Registerutdrag.zip',
      2: 'Mina-spel-Utdrag.zip',
      3: 'Kontohistorik-Utdrag.zip'
    };
    return transcriptFilenames[transcriptionStatus.orderType];
  });
}

if (typeof exports === 'object') {
  registerHelpers(require('hbs'));
} else {
  registerHelpers(Handlebars);
}


 })(window);